import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=b3823788&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"
import style0 from "./wallet.vue?vue&type=style&index=0&id=b3823788&prod&scoped=true&lang=css"
import style1 from "./wallet.vue?vue&type=style&index=1&id=b3823788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3823788",
  null
  
)

export default component.exports